import { CostCenterBase } from './base/cost-center-base';

export class CostCenter extends CostCenterBase { }